import React, { useEffect, useState } from 'react';
import { BoxDataType } from '.';
import { PurchaseDetailsBox } from './PurchaseDetailsBox';
import en from '../../../../lang/en-us';
import { UPDATE_PURCHASE_INFO } from '../../../../redux-store/types/newPurchase';
import { useDispatch } from 'react-redux';
import { CheckBoxField } from '../../../../lib/CheckBoxField';
import { RadioGroup, FormControlLabel, Radio } from '@material-ui/core';
import OptOutModal from '../../makeNct/UpdateNominee/OptOutModal';

const { common, dbCommercial, dashboard } = en;

const initialValues = {
    id: '',
    name: '',
    relation: '',
    percentage: '',
    dob: '',
    pan: '',
    address1: '',
    gender: '',
    address2: '',
    address3: '',
    city: '',
    state: '',
    country: '',
    pincode: '',
    nomineeGuardian: {
        name: '',
        pan: '',
        pekrn: '',
        dob: '',
    },
};
export default function NomineeDetailsPurchase(props: any) {
    const [nomineeDetailsArray, setNomineeDetails] = React.useState<BoxDataType[][]>([]);
    const [showOptOutModal, setShowOptOutModal] = useState(false);
    //try fetching details of nominee from props
    const {
        apiData: { nominees = [], nomineeFlag = false, nomineeInSoa = 'N' },
        kfinFlag,
    } = props;
    const dispatch = useDispatch();
    useEffect(() => {
        const nomineeUiData = nominees.map((nominee: any) => {
            let nomineeDetails: BoxDataType[] = [
                {
                    label: 'Name',
                    value: nominee.name,
                    isEditable: false,
                    apiKey: 'name',
                    name: 'name',
                },
                {
                    label: 'Relation',
                    value: nominee.relation,
                    isEditable: false,
                    apiKey: 'relation',
                    name: 'relation',
                },
                {
                    label: 'Share',
                    value: `${nominee.percentage}%`,
                    isEditable: false,
                    apiKey: 'share',
                    name: 'share',
                },
                {
                    label: 'Gender',
                    value: nominee.gender,
                    isEditable: false,
                    apiKey: 'gender',
                    name: 'gender',
                },
            ];
            return nomineeDetails;
        });
        setNomineeDetails(nomineeUiData);
    }, []);

    const handleDelete = (index: number) => {
        const filteredNominees = nomineeDetailsArray.filter((_: any, i: number) => i !== index);
        dispatch({
            type: UPDATE_PURCHASE_INFO,
            body: { nominees: nominees.filter((_: any, i: number) => i !== index) },
        });
        setNomineeDetails(filteredNominees);
        props.resetError();
    };
    const handleAddNominee = () => {
        let nomineeDetails: BoxDataType[] = [
            {
                label: 'Name',
                value: '',
                isEditable: true,
                apiKey: 'name',
                name: 'name',
            },
            {
                label: 'Relation',
                value: '',
                isEditable: true,
                apiKey: 'relation',
                name: 'relation',
            },
            {
                label: 'Share',
                value: '',
                isEditable: true,
                apiKey: 'share',
                name: 'share',
            },
        ];
        setNomineeDetails((prevState: any) => {
            return [...prevState, nomineeDetails];
        });
        dispatch({
            type: UPDATE_PURCHASE_INFO,
            body: { nominees: [...nominees, initialValues], nomineeFlag: false },
        });
    };

    const handleNomineeFlag = () => {
        if (!nomineeFlag) {
            setShowOptOutModal(true);
        } else {
            dispatch({
                type: UPDATE_PURCHASE_INFO,
                body: { nomineeFlag: false },
            });
        }
    };

    const NoNomineeCheckBox = (
        <>
            <div style={{ display: 'flex', flexDirection: 'row', flexWrap: 'wrap' }}>
                <h2 style={{ marginRight: 20 }}>
                    {dbCommercial.newPurchase.leftMenu.nomineeDetails}
                </h2>
                <CheckBoxField
                    label={dbCommercial.profileDetails.nominees.noNominee}
                    value={nomineeFlag}
                    onChange={handleNomineeFlag}
                />
            </div>
            <OptOutModal
                showModal={showOptOutModal}
                onConfirm={() => {
                    dispatch({
                        type: UPDATE_PURCHASE_INFO,
                        body: { nomineeFlag: true },
                    });
                    setShowOptOutModal(false);
                }}
                onCancel={() => {
                    setShowOptOutModal(false);
                }}
            />
            {!nomineeFlag && nomineeDetailsArray.length === 0 && props.errorSection && (
                <div>
                    {' '}
                    <p style={{ color: 'red' }}> {props.errorSection.message}</p>{' '}
                </div>
            )}
        </>
    );

    if (!nomineeDetailsArray.length || nomineeFlag) {
        return (
            <div className="purchase-section">
                {NoNomineeCheckBox}
                {nomineeDetailsArray.length < 3 && (
                    <div className="add-nominee-btn">
                        <a
                            onClick={() => {
                                handleAddNominee();
                                props.resetError();
                            }}
                        >
                            + Add Nominee
                        </a>
                    </div>
                )}
            </div>
        );
    }

    return (
        <div className="purchase-section">
            {NoNomineeCheckBox}
            {nomineeDetailsArray.map((nomineeDetails, index) => (
                <PurchaseDetailsBox
                    boxDetails={nomineeDetails}
                    heading={`Nominee ${index + 1}`}
                    editRedirect={`${props.isin}/edit/nominee`}
                    kfinFlag={kfinFlag}
                    index={index + 1}
                    canDelete={true}
                    handleDelete={handleDelete}
                    errorSection={
                        !props?.errorSection?.index
                            ? props.errorSection
                            : props?.errorSection?.index === index
                            ? props.errorSection
                            : null
                    }
                />
            ))}

            {nomineeDetailsArray.length <= 2 && (
                <div className="add-nominee-btn">
                    <a onClick={handleAddNominee}>+ Add Nominee</a>
                </div>
            )}

            {!nomineeFlag && (
                <div className="nominee-in-soa-checkbox">
                    <p>{dashboard.UpdateNominee.includeInSOA}</p>
                    <RadioGroup
                        name="nomineeInSoa"
                        value={nomineeInSoa}
                        style={{
                            display: 'flex',
                            flexDirection: 'column',
                            marginTop: '10px',
                        }}
                        onChange={(e) =>
                            dispatch({
                                type: UPDATE_PURCHASE_INFO,
                                body: { nomineeInSoa: e.target.value },
                            })
                        }
                    >
                        <FormControlLabel
                            value="Y"
                            control={<Radio />}
                            label="Name of the Nominee(s)"
                        />
                        <FormControlLabel
                            value="N"
                            control={<Radio />}
                            label="Whether nomination given: Yes / No (not name of the nominee)"
                        />
                    </RadioGroup>
                </div>
            )}
        </div>
    );
}
